// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/lga.scss
// module id = 715
// module chunks = 0